// ManiDine Restaurant App / src/pages/ContactSupportPage.jsx / Updated: 2026-04-18 13:00 MDT
import React from "react";
import ManagerShell from "../components/ManagerShell";

const SUPPORT_EMAIL = "contact@manidine.ca";
const SUPPORT_PHONE = "+1 587 570 8552";

const pageGridStyle = {
  display: "grid",
  gap: 20,
  gridTemplateColumns: "minmax(0, 1.15fr) minmax(320px, 0.85fr)",
  alignItems: "start",
};

const heroCardStyle = {
  position: "relative",
  overflow: "hidden",
  border: "1px solid rgba(138, 49, 255, 0.14)",
  borderRadius: 24,
  padding: 28,
  color: "#fff",
  background:
    "linear-gradient(135deg, rgba(90,59,234,1) 0%, rgba(166,93,216,1) 52%, rgba(240,79,216,1) 100%)",
  boxShadow: "0 24px 60px rgba(90,59,234,0.18)",
};

const infoCardStyle = {
  border: "1px solid rgba(15, 23, 42, 0.08)",
  borderRadius: 20,
  padding: 22,
  background: "#fff",
};

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  padding: "8px 14px",
  borderRadius: 999,
  background: "rgba(255,255,255,0.16)",
  border: "1px solid rgba(255,255,255,0.18)",
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 0.3,
  marginBottom: 16,
};

const infoTileStyle = {
  borderRadius: 18,
  padding: 18,
  background: "rgba(255,255,255,0.14)",
  border: "1px solid rgba(255,255,255,0.16)",
};

const ContactSupportPage = () => {
  return (
    <ManagerShell
      title="Contact Support"
      subtitle="Reach ManiDine support for urgent help, account review, payouts, and restaurant portal issues."
    >
      <div style={pageGridStyle}>
        <section className="dashboard-card" style={heroCardStyle}>
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              top: -70,
              right: -30,
              width: 190,
              height: 190,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.12)",
            }}
          />
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              bottom: -90,
              left: -70,
              width: 210,
              height: 210,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.08)",
            }}
          />

          <div style={{ position: "relative", zIndex: 1 }}>
            <div style={badgeStyle}>ManiDine Restaurant Support</div>

            <h2
              className="card-title"
              style={{
                margin: 0,
                fontSize: 30,
                lineHeight: 1.12,
                fontWeight: 900,
                color: "#fff",
              }}
            >
              Fast support for restaurant operations
            </h2>

            <p
              style={{
                marginTop: 14,
                marginBottom: 0,
                maxWidth: 760,
                color: "rgba(255,255,255,0.94)",
                lineHeight: 1.7,
                fontSize: 15,
              }}
            >
              For account approval, payouts, document review, restaurant setup, menu issues,
              and other portal support, contact ManiDine directly.
            </p>

            <div
              style={{
                marginTop: 22,
                display: "grid",
                gap: 14,
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              }}
            >
              <div style={infoTileStyle}>
                <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.86, marginBottom: 6 }}>
                  SUPPORT PHONE
                </div>
                <div style={{ fontSize: 20, fontWeight: 900, letterSpacing: 0.2 }}>
                  {SUPPORT_PHONE}
                </div>
                <div style={{ marginTop: 6, fontSize: 13, opacity: 0.9, lineHeight: 1.5 }}>
                  Best for urgent issues, active order problems, and anything time-sensitive.
                </div>
              </div>

              <div style={infoTileStyle}>
                <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.86, marginBottom: 6 }}>
                  SUPPORT EMAIL
                </div>
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#fff",
                    fontSize: 18,
                    fontWeight: 800,
                    textDecoration: "none",
                    wordBreak: "break-word",
                  }}
                >
                  {SUPPORT_EMAIL}
                </a>
                <div style={{ marginTop: 6, fontSize: 13, opacity: 0.9, lineHeight: 1.5 }}>
                  Best for non-urgent requests, document review, approvals, and payout questions.
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="dashboard-card" style={infoCardStyle}>
          <h2 className="card-title" style={{ marginTop: 0, marginBottom: 14 }}>
            Best way to reach us
          </h2>

          <div style={{ display: "grid", gap: 16, color: "#475569", lineHeight: 1.65 }}>
            <div>
              <div style={{ fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>
                Urgent issues
              </div>
              <div>
                Use the support phone number for active order problems, account lockouts, or anything
                that needs immediate attention.
              </div>
            </div>

            <div>
              <div style={{ fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>
                Non-urgent issues
              </div>
              <div>
                Email support for payouts, onboarding documents, menu updates, approvals, or general
                restaurant portal questions.
              </div>
            </div>

            <div>
              <div style={{ fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>
                Helpful details to include
              </div>
              <div>
                Restaurant name, account email, issue summary, and order number if the issue is tied to
                a specific order.
              </div>
            </div>
          </div>
        </section>
      </div>
    </ManagerShell>
  );
};

export default ContactSupportPage;
